import React from 'react';

import { useTranslation } from 'i18n/hooks';
import { ErrorBanner, InfoBanner } from 'revibe-ui';

import { MarketplaceAPI } from 'revibe-api';
import { useCart } from 'modules/checkout/hooks/useCart';
import { getAvailableSizes } from '../utils/itemSize';
import { useForm } from 'react-hook-form';
import { CUSTOM_FIELD_TYPES } from '../utils/itemCustomField';

type Props = {
  item: MarketplaceAPI.Item;
};

export const ItemAddToCart = ({ item }: Props) => {
  const { tu } = useTranslation('shop');
  const { cart, addToCart } = useCart();

  const availableSizes = getAvailableSizes(item);
  const colorCustomFields = item.custom_fields.filter(
    (cf) => cf.type === CUSTOM_FIELD_TYPES.COLOR
  );
  const selectCustomFields = item.custom_fields.filter(
    (cf) => cf.type === CUSTOM_FIELD_TYPES.SELECT
  );

  const { handleSubmit } = useForm({
    defaultValues: {
      size: availableSizes[0],
      colors: colorCustomFields.map((cf) => ({
        id: cf.id,
        value: cf.custom_field_values[0],
      })),
      customization: selectCustomFields.map((cf) => ({
        id: cf.id,
        name: cf.name,
        value: cf.custom_field_values[0],
      })),
    },
  });

  if (availableSizes.length === 0) {
    return <ErrorBanner>{tu('out-of-stock')}</ErrorBanner>;
  }

  return (
    <form
      onSubmit={handleSubmit(async (values) => {
        await addToCart({
          cartID: cart?.id,
          item: {
            id: Number(item.id),
            size: values.size.id,
            colors: values.colors.reduce(
              (map, { value }) => `${map}${value}`,
              ''
            ),
            customization: values.customization.reduce(
              (map, { name, value }) => `${map}, ${name}: ${value}`,
              ''
            ),
          },
        });
      })}
      className="flex flex-col gap-6"
    >
      <InfoBanner>
        Uh-oh! Orders are temporarily suspended. Signup to our newsletter to be
        the first to know about our relaunch
      </InfoBanner>
    </form>
  );
};
